type ToggleFeatureToolbarProps = {
    features: Record<string, boolean>;
    toggleFeature: (featureName: string) => unknown;
    toolbarIsOpen: boolean;
    setToolbarIsOpen: (toolbarIsOpen: boolean) => void;
};

export function ToggleFeatureToolbar({ features, toggleFeature }: ToggleFeatureToolbarProps) {
    return (
        <div>
            <div className='text-xs'>Toggle Features </div>
            <ListOfFeatureTogglingCheckboxes
                features={features}
                toggleFeature={toggleFeature}
            />
        </div>
    );
}

const ListOfFeatureTogglingCheckboxes = ({
    features,
    toggleFeature,
}: {
    features: Record<string, boolean>;
    toggleFeature: (featureName: string) => unknown;
}) => (
    <ul className='mx-0 my-1 pl-1'>
        {Object.keys(features).map((featureName) => (
            <li
                key={featureName}
                className='mb-1'
            >
                <label className='cursor-pointer whitespace-nowrap text-xs'>
                    <input
                        type='checkbox'
                        className='mr-1'
                        name={featureName}
                        checked={features[featureName]}
                        onChange={() => toggleFeature(featureName)}
                    />
                    {featureName}
                </label>
            </li>
        ))}
    </ul>
);
